import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { addSavedAddress } from '../../../api/privateApis';
import { getProvinces } from '../../../api/shipmentForms';
import { AbilityContext } from '../../../context/AbilityContext';
import { AddSaveAddressInitialValues } from '../../../initial-values';
import { setProvincesList } from '../../../redux/app/appActions';
import { RootState } from '../../../redux/rootReducer';
import { AddSaveAddressDto, AddressDto } from '../../../types';
import { isValidationValidated } from '../../../utils/helper';
import AddressInput from '../../global-components/addressInput';
import CountriesSelect from '../../global-components/countriesSelect';
import CustomInput from '../../global-components/customInput';
import ProvincesSelect from '../../global-components/provincesSelect';
import SaveAddressModal from './saveAddressModal';
interface Props {
  countriesList: any;
  provincesList: any;
  formData: AddressDto;
  validating: boolean;
  formValidation: any;
  setFormValidation: any;
  postalCodeError: boolean;
  setFormData: React.Dispatch<React.SetStateAction<AddressDto>>;
  sameAddressError?: boolean;
  origin?: boolean;
  isDisabled?: boolean;
}
function AddressForm({
  countriesList,
  provincesList,
  formData,
  validating,
  setFormData,
  formValidation,
  postalCodeError,
  setFormValidation,
  sameAddressError,
  origin,
  isDisabled,
}: Props) {
  const userData = useSelector(
    (state: RootState) => state.mainAppData.userData
  );
  const isVendor = userData?.is_vendor;
  const location = useLocation();
  const isManualShipment = location?.pathname === '/app/admin/manual-shipments';
  const ability = useContext(AbilityContext);
  const [provinces, setProvinces] = useState<any>([]);
  const [saveAddress, setSaveAddress] = useState(false);
  const [isCountryChanged, setIsCountryChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSavedAddressModal, setShowSavedAddressModal] = useState(false);
  const [savedAddressForm, setSavedAddressForm] = useState<AddSaveAddressDto>(
    AddSaveAddressInitialValues
  );

  const dispatch = useDispatch<any>();
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    if (formData.country === '') return;
    getProvinces(formData.country)
      .then((data) => {
        setProvinces(data?.data?.content);
        dispatch(setProvincesList(data?.data?.content));
        if (isCountryChanged) {
          setFormData({
            ...formData,
            province: data?.data?.content[0]?.code,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [formData.country]);
  function savedAddressFunc() {
    if (isValidationValidated(formValidation)) {
      setShowSavedAddressModal(true);
      setSavedAddressForm({
        ...savedAddressForm,
        address: formData,
        username: userData?.username,
        account_number: userData?.account_number,
      });
    } else {
      enqueueSnackbar('Please fill all the fields.', { variant: 'error' });
      setSaveAddress(false);
    }
  }

  function onSave() {
    setLoading(true);
    addSavedAddress(savedAddressForm)
      .then((response) => {
        if (!response?.data?.is_error) {
          setLoading(false);
          setShowSavedAddressModal(false);
          enqueueSnackbar('Address has been added', { variant: 'success' });
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  }
  const handleChange = (value: any) => {
    setFormValidation({
      ...formValidation,
      has_shipping_bays: value !== '' || value !== null || value !== undefined,
    });
    setFormData({
      ...formData,
      has_shipping_bays: value,
    });
  };
  return (
    <div>
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div className={`${isVendor ? 'mt-3' : ''} row mb-3`}>
        {/* <Tooltip id="my-tooltip" /> */}
        <label
          className='col-sm-12 col-form-label globalInputLabel my-auto'
          data-tooltip-id='my-tooltip'
          // data-tooltip-content={"123 Address Road"}
        >
          Address
          <span className='text-danger fw-bold' style={{ marginLeft: '4px' }}>
            *
          </span>
        </label>
        <div className='col-sm-12 '>
          {isDisabled || isVendor ? (
            <input
              id={'address'}
              className='form-control ubbe-input'
              autoComplete='new-password'
              value={formData?.address}
              placeholder={'Address'}
              disabled={isDisabled || isVendor}
            />
          ) : (
            <>
              <AddressInput
                formData={formData}
                setFormData={setFormData}
                formValidations={formValidation}
                setFormValidations={setFormValidation}
                validating={validating}
                countriesList={countriesList}
                sameAddressError={sameAddressError}
                // isDisabled={isDisabled}
              />
              {validating && !formData?.address && (
                <div className='error_text'>
                  {' '}
                  Please provide a valid address.
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <CustomInput
        id={'city'}
        className='form-control ubbe-input'
        label={'City'}
        isDisabled={isDisabled || isVendor}
        type={'text'}
        placeholder={'Municipality, Community, Town, or Village'}
        required
        error={'Please provide a valid city.'}
        value={formData.city}
        validating={validating}
        maxLength={30}
        // isVendor={isVendor}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setFormValidation({
            ...formValidation,
            city: e.target.value !== '',
          });
          setFormData({
            ...formData,
            city: e.target.value,
          });
        }}
      />

      <div className='row mb-3'>
        <label className='col-sm-12 col-form-label globalInputLabel my-auto'>
          Country{' '}
          <span className='text-danger fw-bold' style={{ marginLeft: '4px' }}>
            *
          </span>
        </label>
        <div className='col-sm-12'>
          <CountriesSelect
            onSelect={(val: any) => {
              setFormData({
                ...formData,
                country: val,
                province: '',
              });
              if (val) {
                setIsCountryChanged(true);
              }
            }}
            selectedCountry={formData?.country}
            isDisabled={isDisabled || isVendor}
          />
        </div>
      </div>

      <div className='row mb-3'>
        <label
          className='col-sm-12  col-form-label globalInputLabel my-auto'
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          // title="State, Region"
        >
          Province{' '}
          <span className='text-danger fw-bold' style={{ marginLeft: '4px' }}>
            *
          </span>
        </label>
        <div className='col-sm-12'>
          <ProvincesSelect
            onSelect={(val: any) => {
              setFormData({
                ...formData,
                province: val,
              });
            }}
            provincesList={provinces}
            selectedProvince={formData?.province}
            isDisabled={isDisabled || isVendor}
          />
        </div>
      </div>
      <CustomInput
        id={'postal_code'}
        isDisabled={isDisabled || isVendor}
        className='form-control ubbe-input'
        label={'Postal Code'}
        type={'text'}
        placeholder={'Postal Code, Zip Code, Pin Code, Mailing Code'}
        required
        error={'Please provide a valid postal code/zip code.'}
        value={formData.postal_code}
        validating={validating}
        inValid={postalCodeError}
        maxLength={15}
        // isVendor={isVendor}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          // Replace non-alphanumeric characters with an empty string
          const newValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '');

          // Update form validation and data
          setFormValidation({
            ...formValidation,
            postal_code: newValue !== '', // Update validation based on the new value
          });
          setFormData({
            ...formData,
            postal_code: newValue, // Update form data with the cleaned value
          });
        }}
      />

      <div className='row mb-3'>
        <label className='col-sm-12  col-form-label globalInputLabel my-auto'>
          Residential?{' '}
          <span className='text-danger fw-bold' style={{ marginLeft: '4px' }}>
            *
          </span>
        </label>
        <div className='col-sm-12 '>
          {/* <CustomSelect
              id={'status-dropdown'}
              value={
                formData.has_shipping_bays
                ? '1'
                : formData.has_shipping_bays === null
                ? '-1'
                : '0'
              }
              onChange={(e: any) => {
                setFormData({
                  ...formData,
                  has_shipping_bays:
                  e.target.value === '1'
                  ? true
                  : e.target.value === '-1'
                  ? null
                  : false,
                });
                setFormValidation({
                  ...formValidation,
                  has_shipping_bays:
                    e.target.value === '0' || e.target.value === '1',
                  });
                }}
                isDummyOption={true}
                className={'newstyle_select'}
                options={residentialOption}
                /> */}
          <div className='d-flex gap-4 items-center'>
            <div className='d-flex align-items-center option-radio-click'>
              {' '}
              <input
                type='radio'
                disabled={isDisabled || isVendor}
                name={`shippingBays${origin ? '-origin' : '-destination'}`}
                value='1'
                checked={formData.has_shipping_bays === false}
                onChange={() => handleChange(false)}
              />
              <label
                style={{
                  marginLeft: '4px',
                  // fontWeight: '300',
                  // formData.has_shipping_bays === false ? '300 ' : '400',
                  color: 'var(--Black, #1A141F)',
                  fontFamily: 'Lexend',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  lineHeight: 'normal',
                }}
              >
                Yes
              </label>
            </div>
            <div className='d-flex align-items-center option-radio-click'>
              <input
                type='radio'
                name={`shippingBays${origin ? '-origin' : '-destination'}`}
                value='0'
                disabled={isDisabled || isVendor}
                checked={formData.has_shipping_bays === true}
                onChange={() => handleChange(true)}
              />
              <label
                style={{
                  marginLeft: '4px',
                  // fontWeight: '300',
                  // formData.has_shipping_bays === false ? '400 ' : '300',
                  color: 'var(--Black, #1A141F)',
                  fontFamily: 'Lexend',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  lineHeight: 'normal',
                }}
              >
                No
              </label>
            </div>
          </div>

          {validating && !formValidation.has_shipping_bays && (
            <div className='error_text' id='leg_destination_residential_error'>
              Please specify whether the location is residential.
            </div>
          )}
        </div>
      </div>
      <div className='d-flex row mt-4 '>
        <div className=' text-center'>
          {ability?.can('create', 'Saved Address') && (
            <div className='d-flex gap-2 align-items-center justify-content-center'>
              <input
                className='form-check-input mt-0'
                type='checkbox'
                checked={saveAddress}
                id='save_address'
                disabled={isDisabled}
                onChange={(e) => {
                  setSaveAddress(e.target.checked);
                  if (e.target.checked) {
                    savedAddressFunc();
                  }
                }}
              />
              <label
                className='form-check-label'
                htmlFor='origin_save_address_checkbox'
              >
                Save Address?
              </label>
            </div>
          )}
        </div>
      </div>
      {showSavedAddressModal && (
        <SaveAddressModal
          onClose={() => {
            setShowSavedAddressModal(false);
            setSaveAddress(false);
          }}
          savedAddressForm={savedAddressForm}
          setSavedAddressForm={setSavedAddressForm}
          onSave={onSave}
        />
      )}
    </div>
  );
}

export default AddressForm;
